/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { useEffect, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useParams } from 'react-router';

import { useGetRenewInformationQuery } from 'store/api/version-api.slice';
import useCheckForErrors from 'hooks/useCheckForErrors';

import { getStripePublicKey } from './utils';
import StripeCheckoutForm from './components/StripeCheckoutForm';

const StripeUserPaymentForm = ({ plans, isRenewForm = false, onSubmitHandler, setLoading, userData }) => {
	const params = useParams();

	const { data: renewInfo = {} } = useGetRenewInformationQuery({
		portalId: params.portal_id,
		contactId: params.contact_id
	});

	useCheckForErrors(renewInfo);

	useEffect(() => {
		setLoading(false);
	}, [setLoading]);

	const stripePublicKey = getStripePublicKey(userData);

	const stripePromise = useMemo(() => {
		return stripePublicKey ? loadStripe(stripePublicKey) : null;
	}, [stripePublicKey]);

	const clientSecret = renewInfo?.payment_intent?.client_secret;
	const paymentIntent = renewInfo?.payment_intent?.id;

	if (!stripePromise || !clientSecret) return null;

	return (
		<Elements
			stripe={stripePromise}
			options={{
				clientSecret,
				paymentMethodCreation: 'manual'
			}}
		>
			<StripeCheckoutForm
				isRenewForm={isRenewForm}
				plans={plans}
				onSubmitHandler={onSubmitHandler}
				paymentIntent={paymentIntent}
			/>
		</Elements>
	);
};

export default StripeUserPaymentForm;
